<template>
  <v-container
    fluid
    mt-6
    pa-0
    style="width: 540px"
  >
    <v-card
      class="
        pa-6
        mt-6
        mb-12
      "
    >
      <div
        class="
          d-flex
          justify-center
        "
      >
        <v-img
          src="../assets/logo.png"
          alt="Trouver son cadeau logo"
          max-width="100px"
        />
      </div>

      <h2
        class="
          headline
          text-center
          pb-6
        "
      >Register</h2>

      <v-form
        @submit.prevent="submit()"
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="user.firstname"
          label="Firstname"
          :rules="rules.firstname"
        ></v-text-field>

        <v-text-field
          v-model="user.lastname"
          label="Lastname"
          :rules="rules.lastname"
        ></v-text-field>

        <v-text-field
          v-model="user.email"
          label="Email"
          :rules="rules.email"
        ></v-text-field>

        <v-text-field
          v-model="user.password"
          type="password"
          label="Password"
          :rules="rules.password"
        ></v-text-field>

        <v-text-field
          v-model="passwordConfirmation"
          type="password"
          label="Confirm your password"
          :rules="rules.passwordConfirmation"
        ></v-text-field>

        <v-alert
          type="error"
          v-if="error"
        >{{ error }}</v-alert>

        <v-row
          justify="end"
        >
          <v-btn
            text
            class="mr-3"
            :to="{ name: 'login' }"
          >Sign in</v-btn>

          <v-btn
            :disabled="!valid"
            color="primary"
            type="submit"
            depressed
          >Create an account</v-btn>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      error: null,
      user: {},
      passwordConfirmation: null,
      rules: {
        firstname: [v => !!v || 'Firstname is required'],
        lastname: [v => !!v || 'Lastname is required'],
        email: [v => !!v || 'Email is required'],
        password: [v => !!v || 'Password is required'],
        passwordConfirmation: [
          v => !!v || 'You must confirm your password',
          v => v === this.user.password || 'Passwords must match'
        ]
      }
    }
  },
  methods: {
    async submit() {
      if (!this.$refs.form.validate()) return
      try {
        await this.$axios.post('/register', this.user)
        this.$router.push({ name: 'login' })
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.error = error.response.data
        } else this.error = 'An error occured'
      }
    }
  }
}
</script>
